import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here
import { AppRoutingModule } from './app-routing.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { AppComponent } from './app.component';
import { NavHeaderComponent } from './areas/nav-header/nav-header.component';
import { LanguageUnitsViewComponent } from './areas/language-units-view/language-units-view.component';
import { LanguageUnitsListComponent } from './areas/language-units-list/language-units-list.component';
import { HomePageComponent } from './areas/home-page/home-page.component';

import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

import {CollapseModule} from "ngx-bootstrap/collapse";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    NavHeaderComponent,
    LanguageUnitsViewComponent,
    LanguageUnitsListComponent,
    HomePageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ScrollingModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    CollapseModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
